import { useCallback } from "react";

import { useAppRouter } from "@/lib/navigation/use-app-router";

/** 全局错误恢复动作的默认路由行为。 */
export const useErrorRecoveryHandlers = () => {
  const router = useAppRouter();

  const onRetry = useCallback(() => {
    window.location.reload();
  }, []);

  const onSignIn = useCallback(() => {
    router.replace("/auth/login");
  }, [router]);

  const onGoBack = useCallback(() => {
    router.back();
  }, [router]);

  const onGoHome = useCallback(() => {
    router.replace("/");
  }, [router]);

  return {
    onGoBack,
    onGoHome,
    onRetry,
    onSignIn,
  };
};
